import React from 'react';

const Account: React.FunctionComponent = () => {
    return <div>Edit your account here</div>;
};

export default Account;
